/* @flow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Hls from 'hls.js';

const propTypes = {
  src: PropTypes.string.isRequired,
  type: PropTypes.string,
  video:  PropTypes.object.isRequired,
  onSourceParsed: PropTypes.func.isRequired,
  onSourceError: PropTypes.func.isRequired
};

export default class HLSSource extends Component {
  constructor(props, context) {
    // console.log(props, context);
    super(props, context);
    this.hls = new Hls();

    this.handleParse = this.handleParse.bind(this);
    this.handleErrors = this.handleErrors.bind(this);
  }

  handleErrors (event, data) {
    const { onSourceError } = this.props;
    // console.log('handleErrors: ', data);

    onSourceError(data);

    // if (data.fatal) {
    //   switch(data.type) {
    //   case Hls.ErrorTypes.NETWORK_ERROR:
    //     // try to recover network error
    //     console.log('fatal network error encountered, try to recover');
    //     this.hls.startLoad();
    //     break;
    //   case Hls.ErrorTypes.MEDIA_ERROR:
    //     console.log('fatal media error encountered, try to recover');
    //     this.hls.recoverMediaError();
    //     break;
    //   default:
    //     // cannot recover
    //     console.log('cannot recover');
    //     this.hls.destroy();
    //     break;
    //   }
    // }
  }

  handleParse (event, data) {
    const { onSourceParsed } = this.props;

    console.log('MANIFEST_PARSED: ', data);
    // console.log(data.audio, data.altAudio, data.audioTracks.length);
    const hasSound = data.audio || data.altAudio || !!data.audioTracks.length;

    onSourceParsed({
      hasSound: hasSound,
    });
  }

  componentDidMount() {
    // `src` is the property get from this component
    // `video` is the property insert from `Video` component
    // `video` is the html5 video element
    const { src, video } = this.props;

    // load hls video source base on hls.js
    if (Hls.isSupported()) {
      this.hls.loadSource(src);
      this.hls.attachMedia(video);
    }

    this.hls.on(Hls.Events.MANIFEST_PARSED, this.handleParse);
    this.hls.on(Hls.Events.ERROR, this.handleErrors);
  }

  render() {
    const { src, video, type = 'application/x-mpegURL' } = this.props;

    if (!src || !video) {
      return null;
    }

    return (
      <source
        src={ src }
        type={ type }
      />
    );
  }

}

HLSSource.propTypes = propTypes;



// WEBPACK FOOTER //
// ../src/client/components/videos/HLSSource.js